import { FC } from 'react';
import AnalyticsExportPageFrame, {
  type AnalyticsExportPageProfile,
} from './AnalyticsExportPageFrame';
import AnalyticsExportPieChart, {
  type AnalyticsExportPieSlice,
} from './AnalyticsExportPieChart';
import { analyticsExportTheme as theme } from './analyticsExportTheme';

interface Props {
  title: string;
  subtitle: string;
  slices: AnalyticsExportPieSlice[];
  profile: AnalyticsExportPageProfile;
  pageNumber: number;
  totalPages: number;
}

const AnalyticsExportAudienceDistributionPage: FC<Props> = ({
  title,
  subtitle,
  slices,
  profile,
  pageNumber,
  totalPages,
}) => (
  <AnalyticsExportPageFrame
    title={title}
    subtitle={subtitle}
    profile={profile}
    pageNumber={pageNumber}
    totalPages={totalPages}
    dataCy="analytics_export-public_audience-distribution-page"
  >
    <div className="tw-flex tw-min-h-0 tw-flex-1 tw-flex-col tw-py-8">
      <div className="tw-flex tw-min-h-0 tw-flex-1 tw-items-stretch tw-justify-center">
        <AnalyticsExportPieChart slices={slices} />
      </div>
      <ul className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-8 tw-gap-y-2">
        {slices.map((slice) => (
          <li
            key={slice.label}
            className={`tw-flex tw-items-center tw-gap-2 tw-text-lg ${theme.tileValue}`}
          >
            <span
              className="tw-h-3 tw-w-3 tw-shrink-0 tw-rounded-full"
              style={{ backgroundColor: slice.color }}
            />
            {`${slice.label} ${Math.round(slice.percent)}%`}
          </li>
        ))}
      </ul>
    </div>
  </AnalyticsExportPageFrame>
);

export default AnalyticsExportAudienceDistributionPage;
